import { __decorate, __extends } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import CategorizeBox from "@/components/categorizeBox/index.vue";
import FormPage from "./addEditCopy/index.vue";

var GPSRInfoCopyPage = function (_super) {
  __extends(GPSRInfoCopyPage, _super);

  function GPSRInfoCopyPage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  GPSRInfoCopyPage.prototype.created = function () {};

  GPSRInfoCopyPage = __decorate([Component({
    components: {
      CategorizeBox: CategorizeBox,
      FormPage: FormPage
    }
  })], GPSRInfoCopyPage);
  return GPSRInfoCopyPage;
}(Vue);

export default GPSRInfoCopyPage;